import React, { createContext, useEffect, useRef, useState } from 'react';

export const ServiceContext = createContext({});

function ServiceProvider({ children }) {
    
    const [services] = useState([
        {
            name:"Gustavo Henrique"
        },

        {
            name:"Test"
        },

        {
            name:"Test"
        },
        {
            name:"Test"
        },

        {
            name:"Test"
        },
        
        
    ])

    const getAll = () =>{
    }
    const get = (name) => {
        console.log(services.filter(item => item.name == name))
    }


    return (
        <ServiceContext.Provider value={{get,services}}>
            {children}
        </ServiceContext.Provider>
    );
}

export default ServiceProvider;
